import React from "react";

import { DragDropContext, Droppable } from "@hello-pangea/dnd";
import { Add as AddIcon } from "@material-ui/icons";
import classNames from "classnames";

import TabSelector from "./TabSelector";
import "../../css/admin/tabs.scss";

import type { DropResult } from "@hello-pangea/dnd";
import type { JSX } from "react";

interface TabsProps {
  children: JSX.Element[];
  selectedIndex: number;
  onDragEnd: (result: DropResult) => void;
  onSelectTab: (index: number) => void;
  onAddTab: () => void;
  onSeasonStatusChange: ({
    seasonId,
    enabled,
  }: {
    seasonId: string;
    enabled: boolean;
  }) => void;
  actions: (index: number, data: unknown) => JSX.Element;
  tabClassName?: string;
  tabSelectorClassName?: string;
}

function Tabs({
  children,
  onDragEnd,
  onSelectTab,
  onAddTab,
  selectedIndex,
  actions,
  onSeasonStatusChange,
  tabClassName,
  tabSelectorClassName,
}: TabsProps): JSX.Element {
  const tabClassNames = classNames("tab-content-container", tabClassName);

  return (
    <div className="tab-select">
      <div className="tab-controls">
        <DragDropContext onDragEnd={(result) => onDragEnd(result)}>
          <Droppable
            direction="horizontal"
            droppableId="droppable"
            isDropDisabled={!onDragEnd}
          >
            {(droppableProvided) => (
              <div className="editor-tab-select-items">
                <div ref={droppableProvided.innerRef} className="tabs h-full">
                  {children.map((it, idx) => {
                    if (it.props) {
                      const { label, inputValue, onInputChange, data } =
                        it.props;
                      const itemProps = {
                        label,
                        inputValue,
                        onInputChange,
                        data,
                      };
                      return (
                        <TabSelector
                          // eslint-disable-next-line react/no-array-index-key
                          key={idx}
                          actions={actions}
                          index={idx}
                          itemProps={itemProps}
                          onDragEnd={onDragEnd}
                          onSeasonStatusChange={onSeasonStatusChange}
                          onSelectTab={onSelectTab}
                          selectedIndex={selectedIndex}
                          tabSelectorClassName={tabSelectorClassName}
                        />
                      );
                    }
                    return null;
                  })}
                  {droppableProvided.placeholder}
                </div>
              </div>
            )}
          </Droppable>
        </DragDropContext>
        <div
          className="tab-add flex items-center justify-center"
          onClick={onAddTab}
        >
          <AddIcon />
        </div>
      </div>
      <div className={tabClassNames}>
        {children.map((child, index) => (
          <div
            key={child.key}
            className={index === selectedIndex ? undefined : "hidden"}
          >
            {child}
          </div>
        ))}
      </div>
    </div>
  );
}

export default Tabs;
